import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { toast } from "react-toastify";
import { APP_CONFIG } from "../../constants/constants";
import { logoutEverywhere } from "../../services/authLogoutService";
import { RESPONSE_CODE } from "./constants";

// export const serializeErrorKeyValues = (data: any) => {
//   return Object.keys(data).map((errKey) => {
//     const values: string | string[] = data[`${errKey}`];
//     return typeof values === "string"
//       ? `${errKey === "non_field_errors" ? "" : `${errKey}: `}${values}`
//       : `${errKey === "non_field_errors" ? "" : `${errKey}: `}${values?.join("\n")}`;
//   });
// };
export const serializeErrorKeyValues = (data: any) => {
  return Object.keys(data).map((errKey) => {
    const values = data[errKey];
    if (typeof values === "string") {
      return `${errKey === "non_field_errors" ? "" : `${errKey}: `}${values}`;
    } else if (Array.isArray(values)) {
      return `${errKey === "non_field_errors" ? "" : `${errKey}: `}${values.join("\n")}`;
    } else {
      return `${errKey === "non_field_errors" ? "" : `${errKey}: `}${String(values)}`;
    }
  });
};

// The text of a 400 whose body is {"message": <serializer errors>}, or undefined when there is none.
export const serverErrorMessage = (error: any): string | undefined => {
  const message = error?.data?.message;
  if (!message) return undefined;
  return typeof message === "string"
    ? message
    : serializeErrorKeyValues(message).join(" ");
};

//Handle Error and show alerts.
type THandleAuthErrorCodePropOptions = {
  showFieldErrorToast?: boolean;
  ignore401?: boolean;
};
type THandleAuthErrorCodeFunction = (
  error: FetchBaseQueryError,
  options?: THandleAuthErrorCodePropOptions
) => void;
const handleAuthErrorCode: THandleAuthErrorCodeFunction = (
  error: FetchBaseQueryError,
  options = {
    showFieldErrorToast: false,
    ignore401: false,
  }
) => {
  if (APP_CONFIG.DEBUG.ALL && (window as any).appOnline)
    console.log("[handleAuthErrorCode]", error);
  const { status } = error;
  const data: any = error.data!;

  if (
    status === RESPONSE_CODE.PARSING_ERROR ||
    status === RESPONSE_CODE.FETCH_ERROR
  ) {
    const appOnline = (window as any).appOnline;
    // Handle Error 500 / HTML Response
    // TODO: convert to custom hook and move all messages to translation file
    if (navigator.onLine || appOnline === true) {
      if (document.hasFocus()) {
        toast.error(
          "The system has responded in an unexpected format. Please contact the administrator."
          // { autoClose: false } // allowing failure popup to close
        );
      }
    } else {
      // toast.error("Please check your internet connection.");
    }
  } else if (Number(status) === RESPONSE_CODE.UNAUTHORIZED) {
    if (options.ignore401) return;
    // Handle Error 401
    // (9/18/2025) The toast below has been disabled,
    // instead we rely on `cause: "session-expire"` in `sideEffectLogOut` to show session expire toast
    // ------------------------------------------------------
    // toast.error(
    //   data?.error ??
    //     `Your session has expired. You are being logged out. Please login again.`
    // );
    // (11/5/2024) removed timeout as the delay is not needed
    // setTimeout(() => {
    logoutEverywhere({ redirect: true, cause: "session-expire" });
    // }, 3000)

    // (4/10/2025) following lines commented out for a quick fix to unnecessary display of error messages (esp. on Role Admin Details Page)
    // } else if (data?.msg) {
    //   // Read error from server and display via toast
    //   toast.error(data?.msg);
    // } else if (data?.message) {
    //   // Read error from server and display via toast
    //   toast.error(data?.message);
  } else if (data?.error) {
    // Read error from server and display via toast
    toast.error(data?.error);
  } else if (
    !!status &&
    Math.floor(Number(status) / 100) === 4 &&
    !!data?.meta?.message
  ) {
    // Handle Error 4xx
    toast.error(data?.meta?.message);
  } else if (options?.showFieldErrorToast) {
    // Handle Field Error
    const errors = serializeErrorKeyValues(data);
    toast.error(errors?.join(" "));
  }
};

export { handleAuthErrorCode };
